<template>
  <div>
    <SloTooltip
      :enabled="disabled"
      :text="'Subscription order is being processed and changes to this order can no longer be made.' | t"
      position="bottom"
      class="w-100"
    >
      <SloButton :disabled="disabled" @click="modalOpen = true" fill="outline" class="w-100">
        {{ 'Cancel Subscription' | t }}
      </SloButton>
    </SloTooltip>
    <transition name="fade-up">
      <SloModal v-if="modalOpen" :maxWidth="500" @dismiss="handleCloseModal">
        <template v-slot:title>
          {{ 'Cancel this subscription?' | t }}
        </template>
        <div class="mt-md">
          <p class="m-0 c-gray-800">
            {{ 'Please let us know why you would like to cancel this order.' | t }}
          </p>
          <SloLoader :loading="cancelSubscriptionReasonsLoading" size="xl">
            <SloField class="mt-md">
              <SloLabel>{{ 'Cancellation reason' | t }}</SloLabel>
              <SloSelect
                v-model="selectedCancelSubscriptionReason"
                :placeholder="'Select reason' | t"
                id="cancelReason"
              >
                <option
                  v-for="(cancelSubscriptionReason, index) in cancelSubscriptionReasons"
                  :key="`cancel-subscription-reason-${index}`"
                  v-html="cancelSubscriptionReason.name"
                  :value="cancelSubscriptionReason.code"
                />
              </SloSelect>
            </SloField>
          </SloLoader>
        </div>
        <template v-slot:footer>
          <div class="grid grid-cols-1 gap-md w-100 sm:grid-cols-2">
            <SloButton
              @click="handleCancelSubscription"
              :disabled="cancelSubscriptionLoading || !selectedCancelSubscriptionReason"
              fill="outline"
            >
              <SloLoader :loading="cancelSubscriptionLoading" size="md">
               {{ 'Yes, cancel this order' | t }}
              </SloLoader>
            </SloButton>
            <SloButton @click="handleCloseModal" :disabled="cancelSubscriptionLoading">
              {{ 'No, keep my order' | t }}
            </SloButton>
          </div>
        </template>
      </SloModal>
    </transition>
  </div>
</template>

<script>
import t from '../../main/i18n';
import {marketplaceApi} from '../apis/marketplace';
import SloLoader from '../../../lib/components/SloLoader.vue';
import SloModal from '../../../lib/components/SloModal.vue';
import SloButton from '../../../lib/components/SloButton.vue';
import SloSelect from '../../../lib/components/SloSelect.vue';
import SloField from '../../../lib/components/SloField.vue';
import SloLabel from '../../../lib/components/SloLabel.vue';
import SloTooltip from '../../../lib/components/SloTooltip.vue';

export default {
  name: 'SubscriptionCancel',
  components: {
    SloLoader,
    SloLabel,
    SloField,
    SloSelect,
    SloButton,
    SloModal,
    SloTooltip
  },
  filters: {
    t
  },
  props: {
    disabled: {type: Boolean, default: false},
    subscriptionId: {type: String|Number, required: true}
  },
  data() {
    return {
      modalOpen: false,
      cancelSubscriptionReasonsLoading: true,
      cancelSubscriptionLoading: false,
      cancelSubscriptionReasons: null,
      selectedCancelSubscriptionReason: null
    };
  },
  watch: {
    async modalOpen(isOpen) {
      if (isOpen) {
        this.selectedCancelSubscriptionReason = null;

        await marketplaceApi.getCancelSubscriptionReasons(this.subscriptionId)
          .then(res => {
            this.cancelSubscriptionReasonsLoading = false;
            this.cancelSubscriptionReasons = res.data.cancelReasons;
          })
          .catch(async() => {
            this.$snotify.error(t('Error retrieving skip shipment reasons'));
            await this.$router.push({name: 'marketplace-account-subscriptions'});
          });
      }
    }
  },
  methods: {
    async handleCancelSubscription() {
      this.cancelSubscriptionLoading = true;

      await marketplaceApi.cancelSubscription(
        this.subscriptionId, this.selectedCancelSubscriptionReason
      )
        .then(async() => {
          this.handleCloseModal();
          this.$snotify.success(t('Subscription cancelled'));
          await this.$router.push({name: 'marketplace-account-subscriptions'});
        })
        .catch(() => {
          this.cancelSubscriptionLoading = false;
          this.$snotify.error(t('Unable to cancel subscription'));
        });
    },
    handleCloseModal() {
      this.modalOpen = false;
      this.cancelSubscriptionLoading = false;
    }
  }
};
</script>
